module.exports = __webpack_public_path__ + "img/pr-8.f0dd93b3.png";